import React, { Component } from "react";
import AudioAnalyzer from "./AudioAnalyzer";

export default class SoundGraphic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audio: null
    };
    this.toggleMicrophone = this.toggleMicrophone.bind(this);
  }

  async getMicrophone() {
    const audio = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false
    });
    this.setState({ audio });
  }

  stopMicrophone() {
    this.state.audio.getTracks().forEach(track => track.stop());
    this.setState({ audio: null });
  }

  toggleMicrophone() {
    if (this.state.audio) {
      this.stopMicrophone();
    } else {
      this.getMicrophone();
    }
  }

  componentDidMount() {
    // Create an Audio input
    // start the Audio Input.
    // By default, it does not .connect() (to the computer speakers)
    this.getMicrophone();
  }

  render() {
    return (
      <div className="App">
        <main>
          {/* <div className="controls">
            <button onClick={this.toggleMicrophone}>
              {this.state.audio ? "Stop microphone" : "Get microphone input"}
            </button>
          </div> */}
          {this.state.audio ? <AudioAnalyzer audio={this.state.audio} /> : ""}
        </main>
      </div>
    );
  }
}
